import { createRouter, createWebHistory } from 'vue-router'
import { caseStore } from '@/store/caseStore'

const routes = [
    {
        path: '/',
        redirect: '/create-case'
    },
    {
        path: '/create-case',
        name: 'createCase',
        component: () => import('../pages/CaseCreate.vue')
    },
    {
        path: '/upload-files',
        name: 'uploadFiles',
        component: () => import('../pages/CaseUpload.vue'),
        beforeEnter: (to, from, next) => {
            if (!caseStore.id) {
                next('/create-case')
            } else {
                next()
            }
        }
    },
    {
        path: '/analysis',
        name: 'analysis',
        component: () => import('../pages/Analysis.vue'),
        beforeEnter: (to, from, next) => {
            if (!caseStore.id) {
                next('/create-case')
            } else {
                next()
            }
        }
    },
    {
        path: '/loading-test',
        name: 'loadingTest',
        component: () => import('../pages/LoadingTest.vue')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router


